import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../utils/i18n';
import AnchorButton from '@adsk/bim360-matrix-react-anchor-button';
import Button from '@adsk/bim360-matrix-react-button';
import EmptyState from '@adsk/bim360-matrix-react-empty-state';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import Text from '@adsk/bim360-matrix-react-text';
import classNames from 'classnames';
import IssuesPermissionsDetailModal from './IssuesPermissionsDetailModal';
import IssuesPermissionsTableContainer from './IssuesPermissionsTableContainer';
import IssuesPermissionsBulkSelectionContainer from './IssuesPermissionsBulkSelectionContainer';
import {issuePermissionsAdminVisit} from '../../../utils/analytics-helpers';

class IssuesPermissionsAdmin extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedEntity: {},
      showPermissionsDetailModal: false,
      showPermissionsToggleModal: false,
      showPermissionsToggleConfirmModal: false,
      invalidEntry: false,
      isTableHeaderFixed: false,
      highlightPermissions: []
    };

    this.showDetailsModal = this.showDetailsModal.bind(this);
    this.onBulkCreateSuccess = this.onBulkCreateSuccess.bind(this);
  }

  componentWillMount() {
    this.props.trackEvent(issuePermissionsAdminVisit());
  }

  onBulkCreateSuccess(newPermissions) {
    // Set the new permission rows as highlighted for 4 seconds
    this.setState({highlightPermissions: newPermissions}, () => {
      setTimeout(() => {
        this.setState({highlightPermissions: []});
      }, 4000);
    });
  }

  renderPermissionsDetailModal() {
    return (
      <IssuesPermissionsDetailModal
        container={this.props.container}
        onExited={() => this.setState({showPermissionsDetailModal: false})}
        show={this.state.showPermissionsDetailModal}
      />
    );
  }

  showDetailsModal() {
    this.setState({showPermissionsDetailModal: true});
  }

  _renderTryAgainEmptyState() {
    const tryAgainButton = (
      <Button
        className="IssueTypesAdmin__empty-state-footer"
        onClick={this.props.fetchIssuesPermissions.bind(this)}
        styleType={Button.StyleType.INLINE_LINK}
      >
        {i18n.t('adminPages.emptyState.tryAgain')}
      </Button>
    );
    return (
      <EmptyState
        icon={EmptyState.Icons.CONE}
        className="IssueTypesAdmin__empty-state"
        text={i18n.t('adminPages.emptyState.didntLoad')}
        footer={tryAgainButton}
      />
    );
  }

  renderBulkPermissionSelection() {
    return (
      <IssuesPermissionsBulkSelectionContainer
        onLearnMore={this.showDetailsModal}
        onSuccess={this.onBulkCreateSuccess}
      />
    );
  }

  render() {
    const tableContainerClasses = classNames('IssuesPermissionsAdmin__table', {
      'IssuesPermissionsAdmin__table--header-fixed': this.state.isTableHeaderFixed
    });

    return this.props.fetchError ? (
      this._renderTryAgainEmptyState()
    ) : (
      <div className="IssuesPermissionsAdmin">
        {this.renderBulkPermissionSelection()}
        <div className="IssuesPermissionsAdmin__search-more-information-container">
          <SvgIcon
            className="IssuesPermissionsAdmin__search-more-information-icon"
            svgId="info-circle-small"
            width="16px"
            height="16px"
          />
          <Text className="IssuesPermissionsAdmin__search-more-information" hasHTML>
            {i18n.t('issuesAdmin.permissions.moreInformation')}
          </Text>
          <AnchorButton
            className="IssuesPermissionsAdmin__learn-more"
            data-testid="IssuesPermissionsAdminLearnMore"
            onClick={this.showDetailsModal}
          >
            {i18n.t('issuesAdmin.permissions.learnMore')}
          </AnchorButton>
        </div>
        <IssuesPermissionsTableContainer
          className={tableContainerClasses}
          isPermissionDetailModalOpen={this.state.showPermissionsDetailModal}
          onLearnMore={this.showDetailsModal}
          highlightPermissions={this.state.highlightPermissions}
          container={this.props.container}
        />
        {this.renderPermissionsDetailModal()}
      </div>
    );
  }
}

IssuesPermissionsAdmin.propTypes = {
  container: PropTypes.object,

  // From store
  fetchError: PropTypes.bool,
  isUpdatingPermissions: PropTypes.bool.isRequired,

  // Dispatch
  fetchIssuesPermissions: PropTypes.func.isRequired,
  showNotificationAction: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired
};

IssuesPermissionsAdmin.displayName = 'IssuesPermissionsAdmin';

export default IssuesPermissionsAdmin;
